
  import '/Users/jilin/projects/antd/rc-dialog/docs/demo/bootstrap.md?watch=parent';
  export const texts = [];
  